import { render, staticRenderFns } from "./OutwardTransfers.vue?vue&type=template&id=69275762&"
import script from "./OutwardTransfers.vue?vue&type=script&lang=js&"
export * from "./OutwardTransfers.vue?vue&type=script&lang=js&"
import style0 from "./OutwardTransfers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports